export default __webpack_public_path__ + "static/media/MP0045.9f6f0688.jpg";